// Demo mode is driven by the API's DEMO_MODE env var.
// Fetched once from GET /status on app startup — no frontend env var needed.

let _demoMode = null;

/**
 * Fetches demo mode flag from the API and caches it.
 * Call this once in App.js on startup.
 */
export const loadDemoMode = async () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3800';
  try {
    const res = await fetch(`${BASE_URL}/status`);
    const data = await res.json();
    _demoMode = !!data.demoMode;
  } catch {
    _demoMode = false;
  }
  return _demoMode;
};

/** Returns the cached demo mode flag (false until loadDemoMode() resolves). */
export const isDemoMode = () => _demoMode === true;
